import clsx from 'clsx'
import React, {useContext} from 'react'
import {useHistory} from 'react-router-dom'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import {makeStyles} from 'external/material'

import CloseIcon from '@mui/icons-material/Close'
import IconButton from '@mui/material/IconButton'

import QuestionProperties from './question-properties'
import QuestionTitle from 'components/quiz/components/question-title'
import QuestionValue from 'components/quiz/components/question-value'

import Dialog from 'components/quiz/components/responsive-fullscreen-dialog'
import {createPost} from 'helpers/command'

import matchingHandler from 'components/quiz/edit-questions/matching'
import fillInTheBlanksHandler from 'components/quiz/edit-questions/fill-in-the-blanks'
import multipleChoiceHandler from 'components/quiz/edit-questions/multiple-choice'
import openQuestionHandler from 'components/quiz/edit-questions/open-question'
import trueOrFalseHandler from 'components/quiz/edit-questions/true-or-false'

import Buttons from './buttons'

import {TeacherContext} from 'teacher/context'

import AddStandard from '../add-standard'

const questionHandlers = {
  'matching': matchingHandler,
  'fill-in-the-blanks': fillInTheBlanksHandler,
  'multiple-choice': multipleChoiceHandler,
  'open-question': openQuestionHandler,
  'true-or-false': trueOrFalseHandler
}

const useStyles = makeStyles(newQuestionStyles)

export default function NewBankQuestion (props) {

  const classes = useStyles()
  const history = useHistory()
  const context = useContext(TeacherContext)

  const {translate, updateState, quizQuestionTypes, at, questionId, link, linkQuery, query} = context

  const questionPath = 'quizNewBankQuestion'
  const [question] = at(questionPath)
  const questionType = quizQuestionTypes.find(type => type.id == question.type) || {}
  const Handler = questionHandlers[questionType.name]

  function closeDialog (saved) {
    updateState({quizSearchQuestionBankCalls: {$apply: a => a + 1}})
    history.push(link({}, '/:languageId/:role/:page/:tab', {query: {id: saved ? question.id : undefined}, preserveQuery: !saved}))
  }

  async function handleCancel() {
    await createPost('quiz', 'deleteBankQuestion')({id: question.id})
    closeDialog()
  }

  async function updateProperties (request, updateCommand) {
    const [updatedId] = request
      ? await createPost('quiz', 'updateQuestionProperties')(request)
      : [question.id]
    if (updateCommand && updatedId == question.id) {
      updateState({quizNewBankQuestion: updateCommand})
    }
  }

  const handlePropertyChange = (name, value) => updateProperties({id: question.id, [name]: value}, {[name]: {$set: value}})

  const onStandardsChange = standards => updateProperties(
    {id: question.id, properties: {...question.properties, standards}},
    {properties: {standards: {$set: standards}}}
  )

  return (
    <Dialog
      open={props.open}
      close={closeDialog}
      dialogClasses={classes}
      dialogMaxWidth="lg"
      TitleComponent={() => (
        <Box className="header">
          <Box className="caption">{translate('bank-question-title')}</Box>
          <Buttons onCreate={closeDialog} onCancel={handleCancel} />
        </Box>
      )}
    >
      <Box className="content">
        <Box className="properties-container">
          <QuestionProperties question={question} context={context} />
          <Box className="value-wrapper">
            <QuestionValue context={context} className="value" question={question} updateProperties={updateProperties} />
          </Box>
        </Box>
        <Box className="standards">
          <AddStandard question={question} onStandardsChange={onStandardsChange} />
        </Box>
        {Handler && <Handler
            context={context}
            onPropertyChange={handlePropertyChange}
            updateProperties={updateProperties}
            question={question}
            questionPath={questionPath}
          />}
      </Box>
    </Dialog>
  )
}

function newQuestionStyles(theme) {

  const verticalCentering = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  }

  return {
    root: {
        "& .header" : {
          display: "flex",
          color: '#69738c',
          "& .close-icon": {
            padding: '0 6px',
            "& svg": {
              fontSize: '13pt'
            }
          },
          "& .caption": {
            flexGrow: 1,
            ...verticalCentering
          },
        },
      "& .standards": {
        marginBottom: 10,
      },
      '& .properties-container': {
        display: 'flex',
        marginTop: 20,
        marginBottom: 30
      },
      '& .value-wrapper': {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: 10,
        '& > .value': {
          width: 75,
          '& > .valueLabel': {
            color: '#4e566b'
          },
          '& > .valueInput': {
            display: 'flex',
            // border: 'solid 1px black',
            marginTop: 10,
            borderRadius: 4,
            cursor: 'text',
            padding: 4,
            '& .control': {
              display: 'flex',
            },
            '& .input-wrapper': {
              flexGrow: 1,
              ...verticalCentering
            },
            '& .input': {
              border: 'none',
              width: '100%',
              flexGrow: 1,
              '&:focus': {
                outline: 'none'
              }
            },
            '& .addornment': {
              cursor: 'pointer',
              marginTop: -3,
              ...verticalCentering
            }
          },
        },
      },
    },
    paper: {
      width: 'calc(100% - 64px)'
    }
  }
}
